import { AgendaItem, AgendaItemType } from 'mini-agenda';

/**
 * Function to reuse agenda item references
 * @param oldListOfAgendaItems Existing list of agenda items
 * @param newListOfAgendaItems New list of agenda items
 * @param eventsAddedOrRemovedViaServerEvents List of calendar event keys added/removed via SSE
 */
export default function reuseAgendaItemReferencesIfPresent(
    oldListOfAgendaItems: AgendaItem[],
    newListOfAgendaItems: AgendaItem[]
): AgendaItem[] {
    let agendaListToReturn = [];

    if (oldListOfAgendaItems && oldListOfAgendaItems.length) {
        const mapOfOldAgendaItems: { [key: string]: AgendaItem } = {};

        for (const item of oldListOfAgendaItems) {
            mapOfOldAgendaItems[item.id] = item;
        }

        for (const item of newListOfAgendaItems) {
            const referenceToOldEntry = mapOfOldAgendaItems[item.id];
            if (referenceToOldEntry) {
                agendaListToReturn.push(referenceToOldEntry);
                if (
                    referenceToOldEntry.type === AgendaItemType.Event &&
                    item.event.ItemId.ChangeKey !== referenceToOldEntry.event.ItemId.ChangeKey
                ) {
                    referenceToOldEntry.event = item.event;
                } else if (
                    referenceToOldEntry.type === AgendaItemType.DayMonthSeparator &&
                    item.eventCount !== referenceToOldEntry.eventCount
                ) {
                    referenceToOldEntry.eventCount = item.eventCount;
                }
            } else {
                agendaListToReturn.push(item);
            }
        }
    } else {
        agendaListToReturn = newListOfAgendaItems;
    }

    return agendaListToReturn;
}
